import { useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { backButton as bb, init } from "@telegram-apps/sdk-react";
import { useAtomValue } from "jotai";

import { isTmaEnvironmentAtom } from "@/atoms/ui";
import { BankRoute } from "@/constants/routes";

const backButtonExclude: string[] = [BankRoute.index];

const BackButtonTMA = () => {
  const navigate = useNavigate();
  const location = useLocation();
  init();
  bb.mount();

  const handleBackClick = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  useEffect(() => {
    bb.hide();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!backButtonExclude.includes(location.pathname)) {
      bb.onClick(handleBackClick);
      bb.show();
    } else {
      bb.hide();
    }

    return () => {
      bb.offClick(handleBackClick);
    };
  }, [handleBackClick, location.pathname]);

  return null;
};

const BackButton = () => {
  const isTma = useAtomValue(isTmaEnvironmentAtom);

  if (isTma) return <BackButtonTMA />;

  return null;
};

export default BackButton;
